// extracted by mini-css-extract-plugin
export var baseButton = "_w4-0";
export var controlsArrowKeys = "_w4-1";
export var controlsResetButton = "_w4-2";
export var lightGameButton = "_w4-4 _w4-0";
export var playAgainButton = "_w4-5 _w4-0";
export var startGameButton = "_w4-3 _w4-0";